import React from "react";
import {
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBBtn
} from 'mdb-react-ui-kit';

const Card = ({cardtitle, cardtext}) => {
    return (
    <MDBCard className="mt-5 text-center"> 
      <MDBCardBody>
        <MDBCardTitle className="">{cardtitle}</MDBCardTitle>
        <MDBCardText>
          {cardtext}
        </MDBCardText>
      </MDBCardBody>
    </MDBCard>
    )
}

export default Card;